<template>
    <div>
        <div
            v-if="validGptEmbed"
            class="open-assistant"
        >
            <iframe
                v-if="isOpen"
                :src="botUrl"
                class="open-assistant__iframe"
                scrolling="yes"
                allowfullscreen
                allow="clipboard-read; clipboard-write"
            />
            <button
                class="dn-button base-button open-assistant__toggle"
                :class="{
                    'open-assistant__toggle--move-left': visible
                }"
                aria-label="Open assistant"
                @click="isOpen = !isOpen"
            >
                <span v-if="!isOpen">
                    Ask {{ botName }}
                </span>
                <span v-else>
                    Close {{ botName }}
                </span>
                <BaseIcon
                    v-if="!isOpen"
                    class="dn-icon--square"
                    icon="chat"
                />
                <BaseIcon
                    v-else
                    class="dn-icon--square"
                    icon="close"
                />
            </button>
        </div>
    </div>
</template>
<script setup>
const props = defineProps({
    bot: {
        type: Object,
        required: true,
        default() {
            return {};
        }
    }
});

const { activeSite } = useMultisite();

const { visible } = useScrollUpPosition();

const validGptEmbed = computed(() => {
    const validUrls = [
        'https://agent.uroweb.org'
    ];
    
    if (!props.bot?.externalLink) {
        return false;
    }

    return validUrls.some((url) => props.bot.externalLink.startsWith(url));
});

const botUrl = computed(() => {
    if(!validGptEmbed.value) {
        return;
    }

    return new URL(props.bot.externalLink).toString();
});

const botName = computed(() => {
    if (props.bot.botName) {
        return props.bot.botName;
    } else if (activeSite.value?.handle === 'eauCongress') {
        return 'EAU Congress Bot';
    } else if (activeSite.value?.handle === 'uroweb') {
        return 'EAU Guidelines Bot';
    }
    return 'EAU Bot';
});

const isOpen = ref(false);
</script>
<style lang="less" scoped>
.open-assistant {
    position: fixed;
    right: 1rem;
    bottom: 1rem;
    display: flex;
    flex-direction: column;
    z-index: 2;

    @media screen and (max-width: 481px) {
        left: 1rem;
    }
}

.base-button.dn-button.open-assistant__toggle {
    .typography-label-secondary;
    transition: color var(--transition-fast), margin var(--transition-fast);

    border-radius: 1.875rem 1.875rem 0 1.875rem;
    background: var(--color-darkest);
    border-color: var(--color-darkest);
    color: #fff;
    cursor: pointer;

    height: 4rem;
    margin-left: auto;

    .dn-icon {
        margin-left: 0.5rem;
        font-size: 1.4em;
        color: var(--color-primary);
        fill: var(--color-primary);
    }

    &:hover, &:focus {
        background: var(--color-primary);
        border-color: var(--color-primary);
    }

    &:active {
        background: var(--color-primary-dark);
        border-color: var(--color-primary-dark);
    }

    &:hover, &:focus, &:active {
        color: #fff;

        .dn-icon {
            color: #fff;
            fill: #fff;
        }
    }

    &--move-left {
        margin-right: 3em;

        @media @q-lg-max {
            margin-right: 3.5em;
        }
    }
}

.open-assistant__iframe {
    margin-bottom: 1em;
    right: 0;
    width: 480px;
    max-width: 100%;
    height: 60vh;
    background: #fff;
    border: 1px solid var(--color-gray-200);
    border-radius: var(--borderRadius-sm);
    box-shadow: var(--boxShadow-medium);
}
</style>
